import { setupI18n } from '@lingui/core';
import type { Messages } from '@lingui/core';

export const SUPPORTED_LOCALES = ['en', 'it', 'fr', 'nl'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const i18n = setupI18n();

export async function activateLocale(locale: Locale): Promise<void> {
  const { messages } = (await import(`../locales/${locale}/messages.po`)) as { messages: Messages };
  i18n.loadAndActivate({ locale, messages });
}
